import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Nom de l’organe"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Postes associés"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0 pe-0" }, "Actions")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none fw-semibold text-black" }
const _hoisted_12 = { class: "mb-0 ps-3" }
const _hoisted_13 = { class: "fw-medium" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_15 = { class: "text-end pe-0" }
const _hoisted_16 = { class: "dropdown" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown"
}, " Actions ", -1)
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8" }, null, -1)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8" }, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center text-muted py-4"
}, " Aucun organe trouvé ", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "pagination-area d-md-flex mt-15 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          to: "/ajouter-organe"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Ajouter un organe ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un organe"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_6
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organes || [], (organe, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(organe.nom), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organe.postes || [], (poste) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: poste.id,
                        class: "mb-1"
                      }, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(poste.nomPoste), 1),
                        (poste.arrondissement?.libelle)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_14, " (" + _toDisplayString(poste.arrondissement?.libelle) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("ul", _hoisted_18, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'edit-organes', params: { id: organe.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19,
                            _createTextVNode(" Modifier ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "dropdown-item d-flex align-items-center",
                          onClick: ($event: any) => (_ctx.suppression(organe.id, _ctx.organes, 'organes', `l'organe ${organe.nom}`))
                        }, [
                          _hoisted_21,
                          _createTextVNode(" Supprimer ")
                        ], 8, _hoisted_20)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (!(_ctx.organes?.length) || _ctx.organes.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, _hoisted_24))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}